import { notification } from "antd";

notification.config({
  placement: "topRight",
  bottom: 50,
  duration: 3
});

/*tipus {String}: [success, info, warning, error]*/
const obrirNotificacio = (tipus, titol, descripcio) => {
  notification[tipus]({
    message: titol,
    description: descripcio
  });
};

export const NotificacioError = (titol, descripcio) => {
  obrirNotificacio("error", titol, descripcio);
};

export const NotificacioExit = (titol, descripcio) => {
  obrirNotificacio("success", titol, descripcio);
};

export const NotificacioWarning = (titol, descripcio) => {
  obrirNotificacio("warning", titol, descripcio);
};
